import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { View, FlatList, Image } from 'react-native';
import { Space } from '@redlink/components/atoms';

export const Slider = memo(
  ({ data, width, autoScroll, interval, isCompact }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    const changeSliderIndex = useCallback(() => {
      const nextIndex = currentSlide === data.length - 1 ? 0 : currentSlide + 1;
      setCurrentSlide(nextIndex);
      sliderRef.current &&
        sliderRef.current.scrollToIndex({
          index: nextIndex,
          viewOffset: width * currentSlide,
        });
    }, [currentSlide, data, width]);

    useEffect(() => {
      autoScroll && setTimeout(changeSliderIndex, interval);
      return () => {
        clearTimeout(interval);
      };
    }, [currentSlide, autoScroll, changeSliderIndex, interval]);

    return (
      <FlatList
        ref={sliderRef}
        horizontal
        {...{ data }}
        pagingEnabled
        bounces={false}
        ItemSeparatorComponent={Space}
        keyExtractor={(image) => image}
        showsHorizontalScrollIndicator={false}
        renderItem={({ item }) => (
          <Slide
            image={item.image}
            {...{ width }}
            height={isCompact ? width * 0.72 : width * 0.9}
          />
        )}
      />
    );
  }
);

const Slide = memo(({ image, height, width }) => {
  return (
    <View>
      <Image source={image} style={{ height, width }} resizeMode="contain" />
    </View>
  );
});
